import create from 'zustand'

interface IAutoSuggestionsStore {
  options: Record<string, string[]>;
  setOptions: (k: string, options: string[]) => void;
}

export const useAutoSuggestionsStore = create<IAutoSuggestionsStore>((set) => ({
  options: {},
  setOptions: (k: string, options: string[]) => set(x => ({ ...x, options: { ...(x.options || {}), [k]: options } })),
}));

export const useSetAutoSuggestionsOptions = () => useAutoSuggestionsStore(x => x.setOptions);
